import React, { useCallback, useState, useRef, memo } from 'react';
import { Upload } from 'lucide-react';

import styles from './styles/DragAndDrop.module.css';

const DragAndDrop = ({ 
    onDrop, 
    children,
    overlayText = "Drop any files here",
    icon = <Upload size={48} />,
    overlayClassName,
    dropZoneClassName 
}) => {
    const [isDragging, setIsDragging] = useState(false);
    const dragCounter = useRef(0);

    const handleDragEnter = useCallback(e => {
        e.preventDefault();
        e.stopPropagation();
        dragCounter.current++;
        setIsDragging(true);
    }, []);

    const handleDragLeave = useCallback(e => {
        e.preventDefault();
        e.stopPropagation();
        dragCounter.current--;
        if (dragCounter.current === 0) {
            setIsDragging(false);
        }
    }, []);

    const handleDragOver = useCallback(e => {
        e.preventDefault();
        e.stopPropagation();
    }, []);

    const handleDrop = useCallback(e => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);
        dragCounter.current = 0;

        const files = Array.from(e.dataTransfer.files);
        if (files.length === 0) return;

        if (onDrop) {
            onDrop(files);
        }
    }, [onDrop]);

    return (
        <div 
            className={styles.container}
            onDragEnter={handleDragEnter}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
        >
            {children}

            {isDragging && (
                <div className={`${styles.dragOverlay} ${styles.active} ${overlayClassName || ''}`}>
                    <div className={`${styles.dropZone} ${dropZoneClassName || ''}`}>
                        {icon}
                        <h1>Add anything</h1>
                        <p>{overlayText}</p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default memo(DragAndDrop);
